import { useAuth } from '@/contexts/AuthContext'
import { getVerticalConfig, type VerticalConfig } from '@/config/verticais'

/**
 * Único ponto de leitura do tipo de operação do tenant.
 *
 * Componentes NÃO devem ler `loja.tipo_operacao` diretamente — sempre
 * passar por este hook. Isso isola futuras mudanças (ex: tipo virar array,
 * ou config mover para tabela) em um único lugar.
 */
export function useTipoOperacao(): VerticalConfig {
  const { loja } = useAuth()
  return getVerticalConfig(loja?.tipo_operacao)
}
